module.exports = __webpack_public_path__ + "img/ios_model_100.19d68279.jpg";